import { useDualCredits } from '@/hooks/useDualCredits';
import { Coins, User } from 'lucide-react';
import { cn } from '@/lib/utils';
import { DemoHint } from '@/components/demo/DemoHint';

export function CompanyCreditsBadge({ className }: { className?: string }) {
  const { companyBalance, userBalance, loading } = useDualCredits();

  if (loading) return null;

  return (
    <DemoHint hintKey="section.creditsBadge" side="bottom" showIndicator>
    <div
      className={cn(
        'flex items-center gap-2 rounded-md border border-border bg-muted/50 px-2.5 py-1 text-xs font-semibold text-foreground select-none',
        className
      )}
      title={`Company credits (shared): ${companyBalance} · Your credits (personal): ${userBalance}`}
    >
      <span className="flex items-center gap-1">
        <Coins className="h-3.5 w-3.5 text-brand-teal-deep" />
        {companyBalance.toLocaleString()}
      </span>
      <span className="text-border">·</span>
      <span className="flex items-center gap-1">
        <User className="h-3 w-3 text-muted-foreground" />
        {userBalance.toLocaleString()}
      </span>
    </div>
    </DemoHint>
  );
}
